// Layout
const dashboardLayout = () => import('@/layouts/CompanyLayout/DashboardLayout/dashboardLayout.vue')

const trips = () => import('./views/index')

// start Routes
export default [
  {
    path: '/company/trips',
    component: dashboardLayout,
    children: [{
      path: '',
      name: 'companyTrips',
      meta: {
        name: 'companyTrips',
        parentName: 'trips',
        userType: '',
        permission: '',
        role: 'transportation.company_owner'
      },
      component: trips
    }
    ]
  }
]
